import apiClient from './client';

export const fetchDraftReport = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/draft-report`);
  return data;
};

export const patchReportSection = async (reportId, sectionKey, content) => {
  const { data } = await apiClient.patch(
    `/api/draft-reports/${reportId}/sections/${sectionKey}`,
    { content },
  );
  return data;
};

export const finalizeReport = async (reportId, decision) => {
  const { data } = await apiClient.post(
    `/api/draft-reports/${reportId}/finalize`,
    { decision },
  );
  return data;
};

/**
 * POST /api/cases/:caseNumber/draft-report
 * Persist the agentic-master structured output as the case's latest draft.
 * The GET endpoint returns the most recent row, so this becomes the draft
 * the ReportEditor opens next.
 */
export const saveDraftReport = async (caseNumber, payload) => {
  const { data } = await apiClient.post(
    `/api/cases/${caseNumber}/draft-report`,
    payload,
  );
  return data;
};
